'use strict';

export default function f() {
  'ngInject';

  function setFavicon(href, id) {
    try {
      var head = document.getElementsByTagName('head')[0];
      var faviconId = id;
      var link = document.createElement('link');
      var oldLink = document.getElementById(faviconId);
      link.id = faviconId;
      link.rel = 'shortcut icon';
      link.href = href;
      if (oldLink) {
        head.removeChild(oldLink);
      }
      head.appendChild(link);

      return this;
    } catch(e) {
      //
    }
  }

  return {
    notifyFav() {
      setFavicon('/favicon_notification-32x32.png', 'favicon-32');
      setFavicon('/favicon_notification-16x16.png', 'favicon-16');
      setFavicon('/favicon_notification.ico', 'favicon');
    },

    readFav() {
      setFavicon('/favicon-32x32.png', 'favicon-32');
      setFavicon('/favicon-16x16.png', 'favicon-16');
      setFavicon('/favicon.ico', 'favicon');
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/services/favicon.js